import React, { memo } from 'react';

import { StyledImage, StyledImageImgix } from './Image.styles';

import { ImageProps } from './Image.types';

const Image = ({
  src,
  className,
  alt = '',
  imageWidth,
  imageHeight,
  isLazyLoad = false,
  style = {},
  imgixControlProps = {},
  htmlAttributes = {},
  component: Component = 'img',
  componentClassname = 'image',
  customClassnames = '',
  customStyle = '',
  ...props
}: ImageProps) => {
  const componentProps = {
    ...props,
    className,
    src,
    alt,
    width: imageWidth,
    height: imageHeight,
    style,
  };
  const imgixProps = {
    ...props,
    className,
    alt,
    width: imageWidth,
    height: imageHeight,
    style,
  };
  const imgixParams = {
    auto: 'format',
    fm: src?.includes('.png') ? 'png' : 'jpg',
    ...imgixControlProps,
  };

  return (
    <>
      {src &&
      (src.toLowerCase().includes('images.playosmo') ||
        src.toLowerCase().includes('images.byjuslearning')) ? (
        // TODO: fix the TS errors while moving to the new library
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <StyledImageImgix
          className={`${componentClassname} ${customClassnames}`}
          customStyle={customStyle}
          src={src}
          imgixParams={imgixParams}
          {...imgixProps}
          htmlAttributes={
            isLazyLoad
              ? { loading: 'lazy', ...htmlAttributes }
              : { ...htmlAttributes }
          }
        />
      ) : (
        <StyledImage
          as={Component}
          className={`${componentClassname} ${customClassnames}`}
          customStyle={customStyle}
          {...componentProps}
        />
      )}
    </>
  );
};
Image.displayName = 'Image';

export default memo(Image);
